












import { Component, Mixins, Prop } from "vue-property-decorator";
import InputMethodSelector from "./InputMethodSelector.vue";

@Component({
  components: {
    InputMethodSelector,
  }
})
export default class ToggleFreeInputMethodSelector extends Mixins() {
  @Prop({ default: true })
  isUnselectionEnable: boolean;

  get optionSet(): boolean[] {
    return [ true ];
  }

  get unselection(): boolean {
    return this.isUnselectionEnable ? false : null;
  }

  displayTexts: { key: boolean, text: string }[] = [
    { key: false, text: "入力不可" },
    { key: true, text: "フリー入力" },
  ];
}
